module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 6h-2V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1h-2V2c0-1.106-.894-2-2-2h-8c-1.106 0-2 .894-2 2v4H8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1H2C.894 6 0 6.894 0 8v22c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V8c0-1.106-.894-2-2-2zM18 6h-4V4h4v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/suitcase-2.js
// module id = 1439
// module chunks = 14